import { render, staticRenderFns } from "./ChatProblem.vue?vue&type=template&id=eb7b6b4a&scoped=true"
import script from "./ChatProblem.vue?vue&type=script&lang=js"
export * from "./ChatProblem.vue?vue&type=script&lang=js"
import style0 from "./ChatProblem.vue?vue&type=style&index=0&id=eb7b6b4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb7b6b4a",
  null
  
)

export default component.exports